import { Component, OnInit,Input } from '@angular/core';
import {ModalController} from '@ionic/angular'
import { IonicSelectableComponent } from 'ionic-selectable';
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import {GranServicioDePTWService} from '../gran-servicio-de-ptw.service'
import {ServicioPerfilDeAutoridadService} from '../servicio-perfil-de-autoridad.service'
import { Router } from '@angular/router';
import * as moment from 'moment'
import * as firebase from 'firebase'

//ionic-selectable
class Autoridad{
  public id: number;
  public name: string;
  public email: string;
  public regional: string
}

class GerenteCampo{
  public id: number;
  public name: string;
  public email: string;
  public regional: string;
}

@Component({
  selector: 'app-modal-asignacion-inicial',
  templateUrl: './modal-asignacion-inicial.page.html',
  styleUrls: ['./modal-asignacion-inicial.page.scss'],
})
export class ModalAsignacionInicialPage implements OnInit {

  @Input()ticket
  @Input()granObjetoPTW

  

  //ionic-selectable
  listadeAutoridadesArea: Autoridad[];
  listadeAutoridadesAreaLocal: Autoridad[];  
  listadeAutoridadesElectricas: Autoridad[] = [];
  listadeAutoridadesAislantes:Autoridad[] = [];
  listadeGerentesCampo: Autoridad[] = [];

      
    requiereAutoridadElectrica=false
    requiereAutoridadAislante=false
    requiereGerenteCampo=false
    comentario=''
    dictamenAutHSE={vistobueno:false,comentario:''}


    autoridadHSE={email:'',nombre:'',regional:''}
    autoridadArea={email:'',nombre:'',regional:''}
    autoridadAreaLocal={email:'',nombre:'',regional:''}
    autoridadElectrica={email:'',nombre:'',regional:''}
    autoridadAislante={email:'',nombre:'',regional:''}
    gerenteCampo={email:'',nombre:'',regional:''}



  constructor(public servicioLoadersAlertasService:ServicioLoadersAlertasService,public servicioPerfilDeAutoridadService:ServicioPerfilDeAutoridadService, public granServicioDePTWService:GranServicioDePTWService, private router:Router, private modalController:ModalController) { }

  ngOnInit() {


    this.asignaValores()
    .then(()=>{
      this.cargaAutoridadesArea()
      .catch((err)=>{
        this.servicioLoadersAlertasService.alerta("Error al cargar autoridades de área / Error loading area authorities",err)
      })//asignaValores
    })
    

    
     
  }




  asignaValores(){

    return new Promise (  (resolve)=>{

      if(this.granObjetoPTW.requiereAutoridadElectrica != undefined){
        this.requiereAutoridadElectrica = this.granObjetoPTW.requiereAutoridadElectrica
      }else if(this.granObjetoPTW.requiereAutoridadElectrica == undefined){
        this.requiereAutoridadElectrica = false
      }

  
      if(this.granObjetoPTW.requiereAutoridadAislante != undefined){
        this.requiereAutoridadAislante = this.granObjetoPTW.requiereAutoridadAislante
      }else if(this.granObjetoPTW.requiereAutoridadAislante == undefined){
        this.requiereAutoridadAislante = false
      }
  
      if(this.granObjetoPTW.requiereGerenteCampo != undefined){
        this.requiereGerenteCampo = this.granObjetoPTW.requiereGerenteCampo
      }else if(this.granObjetoPTW.requiereGerenteCampo == undefined){
        this.requiereGerenteCampo = false
      }
  
  
      if(this.granObjetoPTW.autoridadElectrica != undefined){
        this.autoridadElectrica = this.granObjetoPTW.autoridadElectrica
      }else if(this.granObjetoPTW.autoridadElectrica == undefined){
        this.autoridadElectrica ={email:'',nombre:'',regional:''}
      }
  
      if(this.granObjetoPTW.autoridadAislante != undefined){
        this.autoridadAislante = this.granObjetoPTW.autoridadAislante
      }else if(this.granObjetoPTW.autoridadAislante == undefined){
        this.autoridadAislante ={email:'',nombre:'',regional:''}
      }
  
      if(this.granObjetoPTW.autoridadArea != undefined){
        this.autoridadArea = this.granObjetoPTW.autoridadArea
      }else if(this.granObjetoPTW.autoridadArea == undefined){
        this.autoridadArea ={email:'',nombre:'',regional:''}
      }
  
      if(this.granObjetoPTW.autoridadAreaLocal != undefined){
        this.autoridadAreaLocal = this.granObjetoPTW.autoridadAreaLocal
      }else if(this.granObjetoPTW.autoridadAreaLocal == undefined){
        this.autoridadAreaLocal ={email:'',nombre:'',regional:''}
      }
  
      if(this.granObjetoPTW.gerenteCampo != undefined){
        this.gerenteCampo = this.granObjetoPTW.gerenteCampo
      }else if(this.granObjetoPTW.gerenteCampo == undefined){
        this.gerenteCampo ={email:'',nombre:'',regional:''}
      }
  
      this.dictamenAutHSE.vistobueno = this.granObjetoPTW.dictamenAutHSE.vistobueno
      this.dictamenAutHSE.comentario = this.granObjetoPTW.dictamenAutHSE.comentario

      resolve("OK")
    })

    

  }





  //-------------------------------- TOGGLE -----------------------

  autoridadElectricaToggle(){
    if(this.requiereAutoridadElectrica == false){
      this.autoridadElectrica.email=''
      this.autoridadElectrica.nombre=''
      this.autoridadElectrica.regional=''
    }
  }

  autoridadAislanteToggle(){
    if(this.requiereAutoridadAislante == false){
      this.autoridadAislante.email=''
      this.autoridadAislante.nombre=''
      this.autoridadAislante.regional=''
    }
  }

  gerenteCampoToggle(){
    if(this.requiereGerenteCampo == false){
      this.gerenteCampo.email=''
      this.gerenteCampo.nombre=''
      this.gerenteCampo.regional=''
    }

  }

  //-----------------------------CHANGE--------------------

  autoridadAreaChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadArea.email = event.value.email
    this.autoridadArea.nombre = event.value.name
    this.autoridadArea.regional = event.value.regional
  }


  autoridadAreaLocalChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadAreaLocal.email = event.value.email
    this.autoridadAreaLocal.nombre = event.value.name
    this.autoridadAreaLocal.regional = event.value.regional
  }
  

  autoridaElectricaChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadElectrica.email = event.value.email
    this.autoridadElectrica.nombre = event.value.name
    this.autoridadElectrica.regional = event.value.regional
  }

  
  autoridadAislanteChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadAislante.email = event.value.email
    this.autoridadAislante.nombre = event.value.name
    this.autoridadAislante.regional = event.value.regional
  }

  gerenteCampoChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.gerenteCampo.email = event.value.email
    this.gerenteCampo.nombre = event.value.name
    this.gerenteCampo.regional = event.value.regional
  }



  cargaAutoridadesArea(){
    return new Promise((resolve,reject)=>{
  
      this.servicioLoadersAlertasService.presentLoading("Cargando autoridades de área / Loading area authorities")
      this.listadeAutoridadesArea = [];
      let  query = firebase.firestore().collection("autoridades").where("autoridadArea","==",true)
      query.get().then((docs) => {
        docs.forEach((doc) => {
            this.listadeAutoridadesArea.push( { id:this.listadeAutoridadesArea.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        });
        
      }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
        resolve("OK AA")
      }).catch((err) => {
        reject((err))
        console.log(err);
      });
    })
    
  }

  // cargaAutoridadesAreaLocal(){

  //   return new Promise((resolve,reject)=>{
  //     console.log("disparado AAL")
  //     this.servicioLoadersAlertasService.presentLoading("Cargando autoridades de área local")
  //     this.listadeAutoridadesAreaLocal = [];
  //     let  query = firebase.firestore().collection("autoridades").where("autoridadAreaLocal","==",true)
  //      query.get().then((docs) => {
  //        docs.forEach((doc) => {
  //           this.listadeAutoridadesAreaLocal.push( { id:this.listadeAutoridadesAreaLocal.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
  //        });
  //      }).then(()=>{
  //       this.servicioLoadersAlertasService.loadingController.dismiss()
  //       resolve("OK AAL")
  //      }).catch((err) => {
  //       reject(err)
  //        console.log(err);
  //      });
  //   })
  // }


  cargaAutoridadesElectricas(){
    console.warn("cargaAutoridadesElectricas disparada")
    console.warn("this.listadeAutoridadesElectricas.length: "+this.listadeAutoridadesElectricas.length)

    if(this.listadeAutoridadesElectricas.length==0){//ponemos el condicional para que solo se haga el cargue si no está cargada antes para que no se haga lectura cada vez que se toque
      this.servicioLoadersAlertasService.presentLoading("Cargando autoridades eléctricas / Loading electric authorities")
      this.listadeAutoridadesElectricas = [];
      let  query = firebase.firestore().collection("autoridades").where("autoridadElectrica","==",true)
       query.get().then((docs) => {
         docs.forEach((doc) => {
            this.listadeAutoridadesElectricas.push( { id:this.listadeAutoridadesElectricas.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
         });
       }).then(()=>{
         this.servicioLoadersAlertasService.loadingController.dismiss()
       }).catch((err) => {
         console.log(err);
       });
    }
    
  }

  cargaAutoridadesAislantes(){
    if(this.listadeAutoridadesAislantes.length==0){//ponemos el condicional para que solo se haga el cargue si no está cargada antes para que no se haga lectura cada vez que se toque
      this.servicioLoadersAlertasService.presentLoading("Cargando autoridades aislantes / Loading isolating authorities")
      this.listadeAutoridadesAislantes = [];
      let  query = firebase.firestore().collection("autoridades").where("autoridadAislante","==",true)
      query.get().then((docs) => {
        docs.forEach((doc) => {
            this.listadeAutoridadesAislantes.push( { id:this.listadeAutoridadesAislantes.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        });
      }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
      }).catch((err) => {
        console.log(err);
      });
      }
  }

  cargaGerentesCampo(){
    if(this.listadeGerentesCampo.length==0){//ponemos el condicional para que solo se haga el cargue si no está cargada antes para que no se haga lectura cada vez que se toque
      this.servicioLoadersAlertasService.presentLoading("Cargando gerentes de campo / Loading field managers")
      this.listadeGerentesCampo = [];
      let  query = firebase.firestore().collection("autoridades").where("gerenteRegional","==",true)
      query.get().then((docs) => {
        docs.forEach((doc) => {
            this.listadeGerentesCampo.push( { id:this.listadeGerentesCampo.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        });
        this.servicioLoadersAlertasService.loadingController.dismiss()
      }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
      }).catch((err) => {
        console.log(err);
      });
    }
  }


  //------------------------POST---------------
  

  aprobacionfinal(){

    this.validacamposBasicos()
    .then(()=>{
      this.validacamposAutElec()
      .then(()=>{
        this.validacamposAutAislante()
        .then(()=>{
          this.validacamposGerCampo()
          .then(()=>{

              this.dictamenAutHSE.vistobueno=true;
              

              let objetodeupdate={
                autoridadElectrica:this.autoridadElectrica,
                autoridadAislante:this.autoridadAislante,
                autoridadArea:this.autoridadArea,
                gerenteCampo:this.gerenteCampo,
                autoridadAreaLocal:this.autoridadAreaLocal,
                dictamenAutHSE:this.dictamenAutHSE,
                requiereAutoridadElectrica:this.requiereAutoridadElectrica,
                requiereAutoridadAislante:this.requiereAutoridadAislante,
                requiereGerenteCampo:this.requiereGerenteCampo,

                logsAutHSE: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"})
                }

               this.updatefirebase(objetodeupdate)
          })
        })
      })
    })
    
     
     
  
     //----------------
     
     
 
   }

   validacamposBasicos(){
    return new Promise ((resolve,reject)=>{
      if((this.autoridadArea.email !='') ){
        resolve("OK")
      }else
      if(this.autoridadArea.email ==''){
        this.servicioLoadersAlertasService.alerta("Autoridades no asignadas / Authorities not assigned","Seleccione una autoridad de área para continuar / Select an area authority to continue")
        reject()
      }
    })
   }

   validacamposAutElec(){
    return new Promise ((resolve,reject)=>{
      if((this.requiereAutoridadElectrica == true && this.autoridadElectrica.email !='') || this.requiereAutoridadElectrica == false ){
        resolve("OK")
      }else
      {
        this.servicioLoadersAlertasService.alerta("Autoridad eléctrica no asignada / Electric authority not assigned","Seleccione una autoridad eléctrica o desactive la opción de Autoridad eléctrica / Select an electric authority or deactivate the electric authority option")
        reject()
      }
    })
   }

   validacamposAutAislante(){
    return new Promise ((resolve,reject)=>{
      if((this.requiereAutoridadAislante == true && this.autoridadAislante.email !='') || this.requiereAutoridadAislante == false ){
        resolve("OK")
      }else
      {
        this.servicioLoadersAlertasService.alerta("Autoridad aislante no asignada / Isolating authority not assigned ","Seleccione una autoridad aislante o desactive la opción de Autoridad aislante / Select an isolating authority or deactivate the isolating authority option")
        reject()
      }
    })
   }

   validacamposGerCampo(){
    return new Promise ((resolve,reject)=>{
      // if((this.requiereGerenteCampo == true && this.gerenteCampo.email !='') || this.requiereGerenteCampo == false ){
      //   resolve("OK")
      // }else
      // {
      //   this.servicioLoadersAlertasService.alerta("Gerente de campo no asignado","Seleccione un gerente o desactive la opción de Gerente de Campo")
      //   reject()
      // }

      resolve("OK")
    })
   }



  updatefirebase(objetodeUpdate){
    console.log("IDSOLICITUD"+this.granServicioDePTWService.idSolicitud)
    firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update(objetodeUpdate).then(()=>{
        this.servicioLoadersAlertasService.alerta("Solicitud aprobada / Request approved","La solicitud ha sido marcada como aprobada y las autoridades han sido asignadas. ¡Gracias! / The request has been marked as approved and the authorities have been assigned. Thank you!");
    }).then((doc)=>{
      this.modalController.dismiss()
      this.navegar('/menu')
    })
  }


  navegar(entrada){
    this.router.navigateByUrl(entrada);
  } 


  cancelar(){
    this.modalController.dismiss()
  }




  



}// fin de clase




